"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

var _DecisionTreeButton = require("./DecisionTreeButton.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * This component is typically used in the Arthur flow
 */
// intentionally left as a functional component
var DecisionTreeButton = function DecisionTreeButton(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      props = _objectWithoutProperties(_ref, ["children", "icon"]);

  return /*#__PURE__*/_react.default.createElement(_DecisionTreeButton.StyledDecisionTreeButton, _extends({
    colorTheme: "primaryGhost"
  }, props), /*#__PURE__*/_react.default.createElement(_DecisionTreeButton.StyledLabel, {
    "data-test-id": "decision-tree-button-label"
  }, children), icon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    dataTestId: "decision-tree-button-icon",
    iconName: "chevron-right"
  }));
};

DecisionTreeButton.propTypes = {
  /** Text to display within the button */
  children: _propTypes2.default.children,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Flag to disable the button, impacting visibility and click-ability */
  disabled: _propTypes.default.bool,

  /** Flag to enable icon */
  icon: _propTypes.default.bool,

  /** Function to invoke upon being clicked */
  onClick: _propTypes.default.func.isRequired
};
DecisionTreeButton.defaultProps = {
  className: '',
  disabled: false,
  icon: false,
  children: ''
};
var _default = DecisionTreeButton;
exports.default = _default;